import { CheckboxFilter } from "../components/Filters/CheckboxFilter";
import { RangeNumberFilter } from "../components/Filters/RangeNumberFilter";
import { RangeDateFilter } from "../components/Filters/RangeDateFilter";
import { DropdownFilter } from "../components/Filters/DropdownFilter";
import { TextFilter } from "../components/Filters/TextFilter";
import { BarChartFilter } from "../components/Filters/BarChartFilter";
import { FilterType } from "../types";

export const getFilterComponent = (filterType: FilterType) => {
  switch (filterType) {
    case "checkbox":
      return CheckboxFilter;
    case "rangeNumber":
      return RangeNumberFilter;
    case "barChart":
      return BarChartFilter;
    case "rangeDate":
      return RangeDateFilter;
    case "text":
      return TextFilter;
    case "dropdown":
    default:
      return DropdownFilter;
  }
};
